import {FormattedMessage} from 'react-intl';
import {withState, t} from 'shared/core';
import {EmployeeNameWithAvatar, Display, Layout} from 'shared/components';
import {InteractiveTable} from 'main/components';
import {endpoints, types} from 'main/tools';
import CheckinRelation from 'main/stores/performance/CheckinRelation';
import AdminRevieweesContainerState from './state/AdminRevieweesContainerState';

const DaysSinceLastCheckin = ({model}) => {
  if (model.daysSinceLastCheckin == null) {
    return <span className='h6 waterloo'><FormattedMessage id='performance.NO_CHECK_INS'/></span>;
  }

  return (
    <span className='h6 waterloo caps'>
      <FormattedMessage id='performance.DAYS' values={{numberOfDays: model.daysSinceLastCheckin}}/>
    </span>
  );
};

const COLUMNS = [
  {
    header: 'performance.NAME',
    width: 4,
    render: ({reviewee}) => <EmployeeNameWithAvatar employee={reviewee} size='sm'/>
  },
  {
    header: 'performance.LEADER',
    width: 4,
    render: ({reviewer}) => <EmployeeNameWithAvatar employee={reviewer} size='sm'/>
  },
  {
    header: 'performance.DAYS_SINCE_LAST_CHECK_IN',
    width: 4,
    component: DaysSinceLastCheckin
  }
];

const AdminRevieweesContainer = ({uiState, match}) => {
  const {name} = uiState;
  const cycleId = match.params.id;

  return (
    <>
      <Display backPath='/cycles' backTitle={t('performance.Check-In Cycles')} title={name}/>
      <Layout>
        <InteractiveTable
          columns={COLUMNS}
          showLinks={false}
          showAddButton={false}
          showRoute={({reviewee}) => `/cycles/${cycleId}/reviewees/${reviewee.id}`}
          proxy={{
            type: 'async',
            endpoint: endpoints.PERFORMANCE.CYCLE_REVIEWEES_LIST.with(cycleId),
            modelType: types.PERFORMANCE.CHECKIN_RELATIONS,
            model: CheckinRelation
          }}
        />
      </Layout>
    </>
  );
};

export default withState(AdminRevieweesContainer, AdminRevieweesContainerState);
